import { Badge, Group, HoverCard, Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { CrossCameraCamera } from '@/types/crossCamera'

const MAX_VISIBLE = 4

const label = (camera: CrossCameraCamera) =>
  camera.camera_name || camera.camera_id

const CameraBadge = ({ camera }: { camera: CrossCameraCamera }) => (
  <Badge variant="dot" color="blue" size="md" tt="none">
    {label(camera)}
  </Badge>
)

type CrossCameraCameraListProps = {
  cameras: CrossCameraCamera[]
}

export const CrossCameraCameraList = ({
  cameras
}: CrossCameraCameraListProps) => {
  if (cameras.length === 0) {
    return (
      <Text size="sm" c="dimmed">
        <FormattedMessage id="crossCamera.apps.cameras.empty" />
      </Text>
    )
  }

  const visible = cameras.slice(0, MAX_VISIBLE)
  const hidden = cameras.slice(MAX_VISIBLE)

  return (
    <Group gap={4} wrap="wrap">
      {visible.map((camera) => (
        <CameraBadge key={camera.camera_id} camera={camera} />
      ))}

      {hidden.length > 0 && (
        <HoverCard shadow="md" position="top" openDelay={100} withArrow>
          <HoverCard.Target>
            <Badge variant="outline" color="gray" size="sm" tt="none">
              <FormattedMessage
                id="general.plusMore"
                values={{ count: hidden.length }}
              />
            </Badge>
          </HoverCard.Target>

          <HoverCard.Dropdown p="xs">
            <Stack gap={6}>
              {hidden.map((camera) => (
                <CameraBadge key={camera.camera_id} camera={camera} />
              ))}
            </Stack>
          </HoverCard.Dropdown>
        </HoverCard>
      )}
    </Group>
  )
}
